<template lang="html">
  <div class="main">
    <span v-if="show==='reset'">{{message.info2}}</span>
    <span v-if="show==='invite'">{{message.info1}}</span>
    <a href="/app/login">{{message.login}} Cydex</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: {
        login: this.$lang.ui.form.login,
        info1: this.$lang.ui.notice.l102,
        info2: this.$lang.ui.notice.l103
      },
      show: this.$route.query.mode
    }
  }
}
</script>

<style lang="css" scoped>
.main {
  text-align: center;
  font-size: 16px;
  margin-top: 120px;
}
a {
  color: #007bc5;
}
</style>
